export function getDimensionDescription(dimension, language) {
  let content = null;
  switch (dimension.dimensionCode) {
    case "dorHeight":
      content = document.getElementById("tooltip-door-height");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorWidth":
      content = document.getElementById("tooltip-door-width");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorGlassType":
      content = document.getElementById("tooltip-door-glasstype");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorColor":
      content = document.getElementById("tooltip-door-color");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorHanding":
      content = document.getElementById("tooltip-door-handing");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorInsideColor":
      content = document.getElementById("tooltip-door-inside-color");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorSPROSS":
      content = document.getElementById("tooltip-door-spross");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorDesignInside":
      content = document.getElementById("tooltip-door-design-inside");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorHinge":
      content = document.getElementById("tooltip-door-hinge");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorCylinder":
      content = document.getElementById("tooltip-door-cylinder");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorHandle":
      content = document.getElementById("tooltip-door-handle");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorKickplate":
      content = document.getElementById("tooltip-door-kickplate");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorNorGroove":
      content = document.getElementById("tooltip-door-groove");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorDoorBrake":
      content = document.getElementById("tooltip-door-brake");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorHIDDENHINGE":
      content = document.getElementById("tooltip-door-hidden-hinge");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorSECUREDOOR":
      content = document.getElementById("tooltip-door-secure-door");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorExtreme":
      content = document.getElementById("tooltip-door-extreme");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorLock":
      content = document.getElementById("tooltip-door-lock");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "dorYaledoorman":
      content = document.getElementById("tooltip-door-yale-doorman");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwWidth":
      content = document.getElementById("tooltip-window-width");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwHeight":
      content = document.getElementById("tooltip-window-height");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwAdjufix":
      content = document.getElementById("tooltip-window-adjufix");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwColor":
      content = document.getElementById("tooltip-window-color");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwFlynet":
      content = document.getElementById("tooltip-window-flynet");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwHanding":
      content = document.getElementById("tooltip-window-handing");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwInsideColor":
      content = document.getElementById("tooltip-window-inside-color");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwLamination":
      content = document.getElementById("tooltip-window-lamination");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwLockhandle":
      content = document.getElementById("tooltip-window-lock-handle");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwNorGroove":
      content = document.getElementById("tooltip-window-groove");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwPanelheight":
      content = document.getElementById("tooltip-window-panel-height");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwSPROSS":
      content = document.getElementById("tooltip-window-spross");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwSPROSSDUPLEX":
      content = document.getElementById("tooltip-window-spross-duplex");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwSPROSSENERGY":
      content = document.getElementById("tooltip-window-spross-energy");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwTricklevent":
    case "wdwSPALTVENTIL":
      content = document.getElementById("tooltip-window-spalt-ventil");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwWicketDoor":
      content = document.getElementById("tooltip-window-wicket-door");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwWindIso":
      content = document.getElementById("tooltip-window-wind-iso");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwWindStop":
      content = document.getElementById("tooltip-window-wind-stop");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwUvalue":
      content = document.getElementById("tooltip-window-u-value");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    case "wdwMITTPOST":
      content = document.getElementById("tooltip-window-mitt-post");
      return content ? content.innerHTML : dimension[`hintDescription${language}`];
    default:
      return dimension[`hintDescription${language}`];
  }
}